import Mapping from '../model/service.object.mapping';
import Collection from '../collection';





export default Collection.extend( {
    endpoint: '/service-objects/mappings/list?apiVersion=2.0',
    responseAt: 'items',
    model: Mapping
} );


// WEBPACK FOOTER //
// ./src/js/collection/service.object.mappings.js